angular.module('app.general').component('teamLogo', {
  templateUrl: 'general/components/team-logo.html',
  bindings: {
    team: '<',
  },
});
